import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Flex } from '@radix-ui/themes';

import Tooltip from '../../../shared/Tooltip';
import { BroadcastContextProvider } from '../contexts/BroadcastContext.jsx';
import { useBroadcastContext } from '../contexts/BroadcastContext.jsx';
import { StepContainer } from './StepContainer.jsx';
import { Footer } from '../components/Footer.jsx';
import { HeaderContainer } from './HeaderContainer.jsx';
import { PAID } from '../utils/constants';
import { UpgradeBanner } from '../../../shared/UpgradeBanner/index.jsx';

const BroadcastContent = ({ children }) => {
  const {
    tier,
    canSendBroadcast,
    nextFreeBroadcastDate,
  } = useBroadcastContext();

  return (
    <>
      <Tooltip />
      <Container>
        {tier && tier !== PAID && (
          <Flex justify="center" mt="25px" p="0 24px">
            <UpgradeBanner
              icon="fa-regular fa-paper-plane"
              titleKey="broadcast.title"
              countValue={canSendBroadcast ? 1 : 0}
              countLimit={1}
              textContent={(t, Trans) => (
                <>
                  {canSendBroadcast ? (
                    <>
                      {t('broadcast.text1')}
                      <br />
                      <Trans
                        i18nKey="broadcast.text2"
                        components={{ strong: <strong /> }}
                        ns="upgradeBanners"
                      />
                    </>
                  ) : (
                    <Trans
                      i18nKey="broadcast.text3"
                      components={{ strong: <strong /> }}
                      ns="upgradeBanners"
                      values={{
                        date: nextFreeBroadcastDate,
                      }}
                    />
                  )}
                </>
              )}
            />
          </Flex>
        )}
        <Header>
          <HeaderContainer />
        </Header>
        <Content>
          <StepContainer step={children} />
          <Footer />
        </Content>
      </Container>
    </>
  );
};

export const NewBroadcastContainer = props => {
  const { currentStep } = props;

  return (
    <BroadcastContextProvider currentStep={currentStep}>
      <BroadcastContent>{props.children}</BroadcastContent>
    </BroadcastContextProvider>
  );
};

const Header = styled.div`
  align-items: center;
  margin-bottom: 40px;
  display: flex;
  border-bottom: 1px solid ${themeGet('colors.black.10')};
  padding: 12px 20px 12px 20px;
  justify-content: space-between;
`;

const Container = styled.div``;

const Content = styled.div`
  max-width: 1040px;
  margin: 24px;
  margin: 0 auto;
`;
